import * as actions from './actions'
import * as getters from './getters'
import mutations from './mutations'

export default {
  state: {
    isLoadingSchema: false,
    listSchema: [],
    currentSchema: null,
    action: 'selection',
    currentSelection: {
      hasSelection: false
    },
    layerTree: null
  },
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/schemaFonctionnel/index.js